export const userTypeEnum = {
  superadmin: 'superadmin',
  user: 'user',
  api: 'api',
} as const

export type UserTypeEnum = (typeof userTypeEnum)[keyof typeof userTypeEnum]

export type UserType = UserTypeEnum